import React from 'react'
import '../Header/Header.css'
import { NavBar } from '../../ui/NavBar/NavBar'

export const Header = () => {
  return (
    <div className="header">
      <NavBar />
    </div>
  )
}
